// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PFixField } from './PFixField';
export class PFixBooleanField extends PFixField {
    constructor(fieldId, buffer) {
        super(fieldId, buffer);
        this.Value = false;
    }
    ReadValue(buffer) {
        this.Value = buffer.ReadBoolean();
    }
    Write(buffer) {
        buffer.WriteShort(this.FieldId);
        buffer.WriteBoolean(this.Value);
    }
}
